import * as React from "react";
import { Link } from "react-router-dom";


import knowledgeExchange from "../images/KnowledgeExchange.svg";
import smallQuestion from "../images/Question_Small.jpg";
import blueskyLogo from "../images/logos/Bluesky.png";
import mastadonLogo from "../images/logos/Mastodon.png";
import microsoftPartnerLogo from "../images/logos/MicrosoftPartnerSingleLine.png";
import remoteSupport from "../images/RemoteSupportWide.png";

export const Home = () => {
  return (
    <>
      <div className="heroSection">
        <div className="heroText">
          <h1 className="heroTitle">DOMMICRO LLC</h1>
          <p className="heroSubtitle">
            Reliable IT solutions, modern infrastructure, and AI-powered
            innovation — built for businesses that move fast.
          </p>
          <Link to="/contact" className="heroCta">Get in Touch</Link>
        </div>
        <div className="heroImageWrap">
          <img src={knowledgeExchange} alt="Knowledge Exchange" className="heroImg" />
        </div>
      </div>

      <div className="homeContent">

        <section className="homeSection">
          <h3 className="sectionTitle">Driving Innovation and Efficiency</h3>
          <div className="sectionBody">
            <p>
              In today's fast-paced digital world, having a reliable and innovative IT
              partner is essential. At DOMMICRO, we empower businesses with tailored IT
              solutions that drive efficiency, enhance security, and enable growth.
              Whether you're optimizing current operations or embarking on a
              transformative digital journey, we're here to help you succeed.
            </p>
            <p>
              In addition, we understand that innovation thrives with a mix of old and
              new. We encourage the use of proven technologies and techniques, while also
              embracing the latest and greatest.
            </p>
            <p>
              <a href="/Services" className="ctaLink">Learn more about our services</a>
            </p>
          </div>
        </section>

        <div className="sectionDivider" />

        <section className="homeSection homeSectionTinted">
          <h3 className="sectionTitle">AI-Powered Solutions</h3>
          <div className="sectionBody">
            <p>
              Harness the power of artificial intelligence to transform your business
              operations. DOMMICRO brings enterprise-grade AI capabilities to
              organizations of all sizes — from intelligent automation and predictive
              analytics to responsible AI governance.
            </p>
          </div>
          <div className="aiCardsRow">
            <div className="aiFeatureCard">
              <h6>Agentic AI Pipelines</h6>
              <p>
                Automate workflows with LLM-powered agents that handle code review,
                documentation, and decision support — reducing time-to-delivery and
                operational overhead.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>AI-Powered Analytics</h6>
              <p>
                Real-time insights and anomaly detection embedded directly into your
                platforms, enabling faster and smarter business decisions at scale.
              </p>
            </div>
            <div className="aiFeatureCard">
              <h6>Responsible AI Governance</h6>
              <p>
                Responsible AI policies, ethical guardrails, and compliance frameworks
                to keep your AI deployments safe and aligned with your organization's
                values.
              </p>
            </div>
          </div>
        </section>

        <div className="sectionDivider" />

        <section className="homeSection">
          <h3 className="sectionTitle">Remote Support</h3>
          <div className="splitRow">
            <div className="splitRowText">
              <p>
                Our remote support link allows us to securely access your device,
                diagnose issues, and provide real-time troubleshooting. With encrypted
                connections and fast response times, we ensure a seamless and secure
                support experience.
              </p>
              <p>
                <a href="/support" target="_blank" rel="noreferrer" className="ctaLink">
                  Remote Support Link
                </a>
              </p>
            </div>
            <div className="splitRowImage">
              <img
                src={remoteSupport}
                alt="Remote Support"
                style={{ maxWidth: "100%", maxHeight: "260px" }}
              />
            </div>
          </div>
        </section>

        <div className="sectionDivider" />

        <section className="homeSection">
          <h3 className="sectionTitle">Domain Name &amp; Hosting Services</h3>
          <div className="sectionBody">
            <p>
              Looking to establish your online presence? Secure your perfect domain name
              and fast, reliable hosting with ease! Whether you're launching a business,
              blog, or eCommerce store, we've got you covered with affordable domain
              registration and premium hosting solutions.
            </p>
            <p>
              <a href="https://services.dommicro.com" target="_blank" rel="noreferrer" className="ctaLink">
                Find out more
              </a>
            </p>
          </div>
        </section>

        <div className="sectionDivider" />

        <section className="homeSection homeSectionTinted">
          <h3 className="sectionTitle">Make a Payment</h3>
          <div className="sectionBody">
            <p>
              Our secure online payment system allows you to make payments anytime,
              anywhere. It ensures a fast, safe, and hassle-free experience.
            </p>
            <p>
              <a href="https://square.link/u/VxWBUZIK" target="_blank" rel="noreferrer" className="ctaLink">
                Make a payment now
              </a>
            </p>
          </div>
        </section>

        <div className="sectionDivider" />

        <section className="homeSection">
          <h3 className="sectionTitle">Current Project(s) Status</h3>
          <div className="statCardsRow">
            <div className="statCard">
              <div className="statCardLabel">Tasks on Track</div>
              <div className="statCardTextGreen">100%</div>
            </div>
            <div className="statCard">
              <div className="statCardLabel">Overdue Tasks</div>
              <div className="statCardTextGreen">0</div>
            </div>
            <div className="statCard">
              <div className="statCardLabel">Open Issues</div>
              <div className="statCardTextGreen">0</div>
            </div>
            <div className="statCard">
              <div className="statCardLabel">Overdue Issues</div>
              <div className="statCardTextGreen">0</div>
            </div>
          </div>
        </section>

        <div className="sectionDivider" />

        <section className="homeSection homeSectionTinted">
          <h3 className="sectionTitle">Stay Connected</h3>
          <div className="contactCard">
            <div className="splitRow">
              <div className="splitRowImage">
                <img
                  src={smallQuestion}
                  alt="Stay Connected"
                  style={{ maxHeight: "200px" }}
                />
              </div>
              <div className="splitRowText">
                <p>
                  Follow us on social media to keep up with what we are working
                  on, join the conversation, and stay in the loop on the latest
                  from DOMMICRO.
                </p>
                <div className="socialLinks">
                  <a href="https://bsky.app/profile/techguydom.com" target="_blank" rel="noreferrer" className="socialLinkItem">
                    <img src={blueskyLogo} alt="Bluesky" className="socialIcon" />
                    <div>
                      <div style={{ fontWeight: 700 }}>Bluesky</div>
                      <div style={{ fontSize: "0.85rem", color: "#4a6278" }}>@TechGuyDom.com</div>
                    </div>
                  </a>
                  <a href="https://twit.social/@TechGuyDom" target="_blank" rel="noreferrer" className="socialLinkItem">
                    <img src={mastadonLogo} alt="Mastodon" className="socialIcon" />
                    <div>
                      <div style={{ fontWeight: 700 }}>Mastodon</div>
                      <div style={{ fontSize: "0.85rem", color: "#4a6278" }}>@TechGuyDom on twit.social</div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="sectionDivider" />

        <div className="partnerRow">
          <div className="partnerBadge">
            <img
              src={microsoftPartnerLogo}
              alt="Microsoft Partner Logo"
              style={{ maxHeight: "72px" }}
            />
          </div>
        </div>

      </div>
    </>
  );
};
